// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e1181c9f","239":"4d8187ea","667":"30512fe1"}[chunkId] + ".chunk.js";
};